import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  cloudWrapper: {
    width: theme.spacing(11.5),
  },
  headerContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  keywordList: {
    margin: theme.spacing(4, 0),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  subHeadingContainer: {
    margin: theme.spacing(3, 0),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  subHeading: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.tertiary,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  emptyState: {
    marginTop: theme.spacing(4),
  },
  aiButtonColor: {
    '&.MuiButton-outlined': {
      color: theme.palette.select.light,
    },
    '&.Mui-disabled': {
      color: theme.palette.button.disabled,
    },
  },
  horizontalDivider: {
    height: theme.spacing(0.125),
    width: '100%',
    backgroundColor: theme.palette.dividerV2.main,
  },
  tipsClasses: {
    backgroundColor: '#E1F0F3',
    padding: theme.spacing(1.25, 2),
    fontSize: '14px',
    cursor: 'pointer',
    gap: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.spacing(0.5),
    fontFamily: theme.typography.fontFamily,
    lineHeight: '20px',
    fontWeight: 500,
    letterSpacing: '0.2px',
    fontStyle: 'normal',
  },
  title: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.primary,
    fontSize: '22px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '28px',
    letterSpacing: '0.25px',
  },
  tipsContentWrapper: {
    display: 'flex',
    gap: '6px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  infoIcon: {
    color: theme.palette.select.light,
    marginBottom: '-2px',
  },
  rightButtonWrapper: {
    display: 'flex',
    gap: theme.spacing(3),
    alignItems: 'center',
    justifyContent: 'center',
  },
  scrollWrapper: {
    height: 'calc(100vh - 240px)',
    overflowY: 'auto',
  },
  wrapper: { marginTop: theme.spacing(3), marginBottom: theme.spacing(3) },
  sidepanelText: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.textField.main,
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.25px',
  },
  aiParentWrapper: { display: 'flex', gap: '32px', flexDirection: 'column' },
  aiWrapper: { display: 'flex', gap: '12px', flexDirection: 'column' },
  modalHeading: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.textField.main,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.25px',
  },
}))
